import { render } from "./VaccinationLog.vue?vue&type=template&id=44ca6f01"
import script from "./VaccinationLog.vue?vue&type=script&lang=js"
export * from "./VaccinationLog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__